import Vue from 'vue'
import Vuex from 'vuex'
import { loadUserInfo, setUserInfo, clearAuth } from '../utils/auth'
import { loginWithJwt } from '../api/user'
import { isCmccEnvironment } from '../utils/bridge'
import { onUnauthorized } from '../utils/http'

Vue.use(Vuex)

var readyResolve
var readyPromise = new Promise(function(r) { readyResolve = r })

var store = new Vuex.Store({
  state: {
    isCmccApp: false,
    isLoggedIn: false,
    authToken: '',
    userInfo: null,
    currentTab: 'home',
    isLoading: false
  },
  mutations: {
    SET_CMCC_ENV(state, val) {
      state.isCmccApp = val
    },
    SET_AUTH_TOKEN(state, token) {
      state.authToken = token
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
    },
    SET_LOGIN_STATUS(state, status) {
      state.isLoggedIn = status
    },
    SET_CURRENT_TAB(state, tab) {
      state.currentTab = tab
    },
    SET_LOADING(state, val) {
      state.isLoading = val
    },
    UPDATE_USER_EXP(state, exp) {
      if (state.userInfo) {
        state.userInfo.exp = (state.userInfo.exp || 0) + exp
      }
    }
  },
  actions: {
    async initApp({ commit }) {
      try {
        commit('SET_CMCC_ENV', isCmccEnvironment())
        var params = new URLSearchParams(window.location.search)
        var jwt = params.get('jwt') || params.get('jwt_token')
        if (jwt) {
          var jwtUser = await loginWithJwt(jwt)
          if (jwtUser.token) {
            commit('SET_AUTH_TOKEN', jwtUser.token)
          }
          var userInfo = {
            userId: jwtUser.userId,
            username: jwtUser.username || '',
            nickname: jwtUser.nickname || '游戏玩家',
            avatar: jwtUser.avatar || '',
            registerTime: jwtUser.registerTime || '',
            level: 1,
            exp: 0,
            totalExp: 100,
            levelName: '青铜玩家',
            levelIcon: '🥉',
            gameRecordCount: 0,
            totalPlayTime: '0小时'
          }
          commit('SET_USER_INFO', userInfo)
          commit('SET_LOGIN_STATUS', true)
          return
        }

        commit('SET_AUTH_TOKEN', '')
        commit('SET_USER_INFO', null)
        commit('SET_LOGIN_STATUS', false)
      } finally {
        readyResolve()
      }
    },
    async refreshUserInfo({ commit, state }) {
      var userId = state.userInfo && state.userInfo.userId
      var userInfo = await loadUserInfo(userId)
      commit('SET_USER_INFO', userInfo)
    },
    updateUser({ commit }, data) {
      commit('SET_USER_INFO', data)
      setUserInfo(data)
    },
    addExp({ commit, state }, exp) {
      commit('UPDATE_USER_EXP', exp)
      if (state.userInfo) {
        setUserInfo(state.userInfo)
      }
    },
    logout({ commit }) {
      commit('SET_AUTH_TOKEN', '')
      commit('SET_USER_INFO', null)
      commit('SET_LOGIN_STATUS', false)
      clearAuth()
    }
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    userInfo: state => state.userInfo,
    username: state => state.userInfo?.username || '未登录',
    userId: state => state.userInfo?.userId || '',
    userLevel: state => state.userInfo?.level || 1,
    userExp: state => state.userInfo?.exp || 0,
    userAvatar: state => state.userInfo?.avatar || '',
    isCmccApp: state => state.isCmccApp,
    authToken: state => state.authToken,
    currentTab: state => state.currentTab,
    waitForReady: () => readyPromise
  }
})

onUnauthorized(function() {
  store.dispatch('logout')
})

export default store
